import { isConnectionError } from "../api.js";

// Поиск «Найти» (T23c): карточки — из /api/quote (один getVariants с высшим приоритетом), а пачка
// /api/lengths для ячеек календаря догружается следом, и «Найти» её не ждёт. Если цены длин для
// даты и взрослых уже загружены и содержат нужную длину — сети нет вовсе.
export const lengthsKey = (from, adults) => `${from}|${adults}`;

// Есть ли длина L в ответе lengths/quote: partial-ответ без L — «неизвестно», а не «недоступно»
export function hasNight(data, L) {
  return (data?.nights ?? []).some((n) => n.L === L);
}

// Повтор quote (T24): после таймаута или обрыва — ровно одна вторая попытка (на сервере quote
// single-flight + кэш, повтор присоединяется к идущему). Не удалась и она — этот текст в тост
export const RETRY_FAILED_TEXT =
  "Не удалось связаться с сервером — проверьте интернет и нажмите «Найти» ещё раз.";
// Пауза перед повтором: мгновенный обрыв (смена Wi-Fi ↔ LTE, сброс после сна вкладки) через 0 мс
// с большой вероятностью упал бы снова, а надпись о повторе гость не успел бы прочитать
export const RETRY_PAUSE_MS = 400;

// Ответы сервера (409 правил, 5xx, 429) — как есть с любой попытки, повтор только для ошибок связи
async function quoteWithRetry(api, params, { onRetry, retryPauseMs }) {
  try {
    return await api.getQuote(params);
  } catch (err) {
    if (!isConnectionError(err)) throw err;
  }
  onRetry?.();
  if (retryPauseMs > 0) await new Promise((r) => setTimeout(r, retryPauseMs));
  try {
    return await api.getQuote(params);
  } catch (err) {
    if (!isConnectionError(err)) throw err;
    throw Object.assign(new Error(RETRY_FAILED_TEXT), { code: err.code, retried: true });
  }
}

// lengths — слот store.lengths ({ key, data, loading, error }); loadLengths — загрузчик index.js
// (сам глотает ошибки и не дублирует полёт по ключу); onRetry — зовётся перед второй попыткой
// quote (индикация в UI). Возвращает данные в формате /api/lengths.
export function runSearch({
  from,
  to,
  adults,
  children,
  L,
  lengths,
  api,
  loadLengths,
  onRetry,
  retryPauseMs = RETRY_PAUSE_MS,
}) {
  if (lengths?.key === lengthsKey(from, adults) && lengths.data && hasNight(lengths.data, L))
    return Promise.resolve(lengths.data);
  // quote уходит первым (async-функция бежит синхронно до первого await — до loadLengths никаких
  // пауз); пачка длин — фоном, без await (на сервере bg=1 ставит её после quote)
  const found = quoteWithRetry(api, { from, to, adults, children }, { onRetry, retryPauseMs });
  loadLengths(from, adults);
  return found;
}

// 409 правил от /api/quote (формат /api/book): причина уходит в блок результатов, не в тост
export function isRulesRefusal(err) {
  return err?.status === 409 && err?.body?.code === "rules";
}

// Пустой снимок поиска в формате lengths — блок «ничего не нашлось» с причиной правила
export function refusedSearchData(from, to, L) {
  return { from, to, nights: [{ L, cats: [] }], tariffs: [], cats: {} };
}
